import { IResponsibilityApprovalRequest } from '../../../../models/responsibilityApprovalRequest.model';
import { AppAction } from '../../../../state/app';
import { FAILURE, REQUEST, SUCCESS } from '../../../../utils/actionTypeUtil';
import {
  CLEAR_PENDING_APPROVAL_RESPONSIBILITY_LIST,
  FETCH_PENDING_APPROVAL_RESPONSIBILITY_LIST,
} from './pendingApprovalResponsibilityList.actions';

export interface PendingApprovalResponsibilityListState {
  loading: boolean;
  items: ReadonlyArray<IResponsibilityApprovalRequest>;
  errorMessage: string;
  totalItems: number;
}

const initialState: PendingApprovalResponsibilityListState = {
  errorMessage: '',
  items: [],
  loading: false,
  totalItems: 0,
};

export default (
  state: PendingApprovalResponsibilityListState = initialState,
  action: AppAction,
): PendingApprovalResponsibilityListState => {
  switch (action.type) {
    case REQUEST(FETCH_PENDING_APPROVAL_RESPONSIBILITY_LIST):
      return { ...state, loading: true };
    case SUCCESS(FETCH_PENDING_APPROVAL_RESPONSIBILITY_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_PENDING_APPROVAL_RESPONSIBILITY_LIST):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case CLEAR_PENDING_APPROVAL_RESPONSIBILITY_LIST:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
